import * as z from "zod";

export const setAptosIntegration = {
  name: "setAptosIntegration" as const,
  input: z.object({
    clientName: z.string().min(1, "Client name is required"),
    guid: z.string().min(1, "Guid is required"),
    endpointUrl: z.string().url("A valid OrderService URL is required"),
  }),
  output: z.object({}),
};

export type SetAptosIntegrationInput = z.infer<
  typeof setAptosIntegration.input
>;

export const updateAptosIntegration = {
  name: "updateAptosIntegration" as const,
  input: z.object({
    clientName: z.string().min(1).optional(),
    guid: z.string().min(1).optional(),
    endpointUrl: z.string().url().optional(),
    enabled: z.boolean().optional(),
  }),
  output: z.object({}),
};

export type UpdateAptosIntegrationInput = z.infer<
  typeof updateAptosIntegration.input
>;

export const getAptosIntegration = {
  name: "getAptosIntegration" as const,
  input: z.object({}),
  output: z.object({
    aptosIntegration: z.optional(
      z.object({
        clientName: z.string(),
        endpointUrl: z.string().nullable(),
        enabled: z.boolean(),
        ordersSyncAt: z.date().nullable(),
        ordersLiveSyncedAt: z.date().nullable(),
        ordersBackfilled: z.boolean(),
      }),
    ),
  }),
};

export type GetAptosIntegrationOutput = z.infer<
  typeof getAptosIntegration.output
>;

export const disconnectAptosIntegration = {
  name: "disconnectAptosIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
